import { Text } from '@dixa/lib-shared-habla';
import { client as elevioClient } from 'elevio';

import { articles } from 'utils/elevio';

import { useSearchFeedback } from '../../utils';

import styles from './searchFeedback.module.scss';

export const SearchFeedback = (): JSX.Element => {
  const sendFeedback = useSearchFeedback();

  const feedbackLink = (
    <Text.ExternalLink className={styles.link} onClick={sendFeedback}>
      Send feedback
    </Text.ExternalLink>
  );

  const learnMoreLink = (
    <Text.ExternalLink
      className={styles.link}
      onClick={() => elevioClient.openArticle(articles.search.documentation)}
    >
      learn more
    </Text.ExternalLink>
  );

  return (
    <Text.Paragraph>
      Not the results you expected? {feedbackLink} or {learnMoreLink}.
    </Text.Paragraph>
  );
};
